// src/Client.ts
import { rpcResult, rpcResponse } from "./common.mjs";
import { assert } from "@chainflip/utils/assertion";
var Client = class {
  constructor(url) {
    this.url = url;
  }
  getRequestId() {
    return "1";
  }
  formatRequest(method, params) {
    return { jsonrpc: "2.0", id: this.getRequestId(), method, params };
  }
  async sendRequest(method, ...params) {
    const response = await this.send(this.formatRequest(method, params));
    if (!response.success)
      throw response.error;
    const parseResult = rpcResponse.safeParse(response.result);
    assert(parseResult.success, "Malformed RPC response received");
    if ("error" in parseResult.data) {
      throw new Error(
        `RPC error [${parseResult.data.error.code}]: ${parseResult.data.error.message}`
      );
    }
    return rpcResult[method].parse(parseResult.data.result);
  }
  methods() {
    return Object.keys(rpcResult).sort();
  }
};
export {
  Client as default
};
